<template>
<div class="resetpwd">
  <div class="content">
    <div class="sx_box">
      <div class="img_box" v-for="(item,index) in sxList" :key="index">
        <img
          ondragstart="return false;"
          :class="[index==clickindex? className:'','sx_img',item.className,'cursor']"
          :src="item.normal"
        />
        <img
          ondragstart="return false;"
          :class="['sx_img',item.className,'cursor']"
          :src="item.normal"
          alt="加载失败"
        />
        <i>{{item.classNameCn}}</i>
        <em :class="item.className" @mouseup="chooseUserClick(item.dataVal,item.normal,index)"></em>
      </div>
    </div>
    <span class="tishi">{{Message}}</span>
    <div class="mima_box">
      <span :class="['bogin_bg_0',shake? 'shake':'' ]">
        <img
          ondragstart="return false;"
          v-show="passwordList[0]"
          :class="[hidden? 'hidden':'' ]"
          :src="passwordList[0]"
        />
      </span>
      <span :class="['bogin_bg_1',shake? 'shake':'' ]">
        <img
          ondragstart="return false;"
          v-show="passwordList[1]"
          :class="[hidden? 'hidden':'' ]"
          :src="passwordList[1]"
        />
      </span>
      <span :class="['bogin_bg_2',shake? 'shake':'' ]">
        <img
          ondragstart="return false;"
          v-show="passwordList[2]"
          :class="[hidden? 'hidden':'' ]"
          :src="passwordList[2]"
        />
      </span>
    </div>
    <span class="clearpassword cursor" @click="clearPassword">清空</span>
  </div>
  <div class="tipbtn">
    <div class="tip">{{step == 1 ? '请输入一个新密码' : '请再输一遍吧'}}</div>
    <div class="haili"></div>
    <div class="login_btn"
      :class="{'login_btn_cur': passwordList.length === 3}"
      @click="next">
      {{step == 1 ? '下一步' : '确认'}}
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      Message: "输入密码",
      hidden: false,
      userPwd: "",
      userPwdAgain: '',
      step: 1,
      shake: false,
      clickindex: null,
      classIndex: -1,
      classList: ["animation_move1", "animation_move2", "animation_move3"],
      passwordList: [],
      sxList: [
        {
          normal: "/static/img/sx/shu.png",
          dataVal: "01",
          className: "shu",
          classNameCn: "鼠"
        },
        {
          normal: "/static/img/sx/niu.png",
          dataVal: "02",
          className: "niu",
          classNameCn: "牛"
        },
        {
          normal: "/static/img/sx/hu.png",
          dataVal: "03",
          className: "hu",
          classNameCn: "虎"
        },
        {
          normal: "/static/img/sx/tu.png",
          dataVal: "04",
          className: "tu ",
          classNameCn: "兔"
        },
        {
          normal: "/static/img/sx/long.png",
          dataVal: "05",
          className: "long ",
          classNameCn: "龙"
        },
        {
          normal: "/static/img/sx/she.png",
          dataVal: "06",
          className: "she",
          classNameCn: "蛇"
        },
        {
          normal: "/static/img/sx/ma.png",
          dataVal: "07",
          className: "ma",
          classNameCn: "马"
        },
        {
          normal: "/static/img/sx/yang.png",
          dataVal: "08",
          className: "yang",
          classNameCn: "羊"
        },
        {
          normal: "/static/img/sx/hou.png",
          dataVal: "09",
          className: "hou",
          classNameCn: "猴"
        },
        {
          normal: "/static/img/sx/ji.png",
          dataVal: "10",
          className: "ji",
          classNameCn: "鸡"
        },
        {
          normal: "/static/img/sx/gou.png",
          dataVal: "11",
          className: "gou",
          classNameCn: "狗"
        },
        {
          normal: "/static/img/sx/zhu.png",
          dataVal: "12",
          className: "zhu",
          classNameCn: "猪"
        }
      ]
    };
  },
  computed: {
    className() {
      if (this.classIndex != -1) {
        return this.classList[this.classIndex];
      }
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    ...mapActions(["getLoginInfo"]),
    ...mapMutations(["refreshNet"]),
    resetStatus() {
      this.userPwd = ""
      this.userPwdAgain = ''
      this.hidden = false;
      this.classIndex = -1;
      this.clickindex = null;
      this.passwordList = []
      this.step = 1
    },
    //清除密码
    clearPassword(event) {
      this.hidden = true;
      setTimeout(() => {
        this.classIndex = -1;
        this.passwordList = [];
      }, 300);
      this.Message = "输入密码";
      if (this.step == 1) {
        this.userPwd = "";
      } else {
        this.userPwdAgain = ''
      }
    },
    next() {
      if (this.step == 1 && this.passwordList.length === 3) {
        this.step = 2
        this.classIndex = -1;
        this.passwordList.splice(0,this.passwordList.length)
      } else if (this.step == 2 && this.passwordList.length === 3) {
        this.makeSure()
      }
    },
    makeSure() {
      if (this.userPwd === this.userPwdAgain) {
        this.$emit('setPwd', this.userPwd)
      } else {
        this.$emit('showSetTip', false)
      }
    },
    //点击密码图
    chooseUserClick(id, src, idx) {
      if (this.passwordList.length === 3 || this.clickindex != null) return;
      this.classIndex += 1;
      this.clickindex = idx;
      setTimeout(() => {
        this.hidden = false;
        this.clickindex = null;
        this.passwordList.push(src);
        if (this.step == 1) {
          this.userPwd += id;
        } else {
          this.userPwdAgain += id;
        }
      }, 400);
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.resetpwd{
  position: relative;
  display: flex;
  align-items: center;
.content {
    position: relative;
    width: 543px;
    height: 543px;
    .sx_box {
      width: 100%;
      height: 100%;
      background: url("../../assets/img/password/password_ground.png") center
        no-repeat;
      background-size: 100%;
      /*animation: roate 1s;*/
      .img_box:hover i {
        display: block;
      }
      i {
        background: url("../../assets/img/password/qipao_right.png")
          no-repeat center;
        background-size: 100%;
        width: 172px;
        height: 146px;
        font-size: 55px;
        color: #fff;
        line-height: 146px;
        display: none;
        z-index: 20;
        position: absolute;
        pointer-events: none;
      }
      em {
        position: absolute;
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: #003057;
        opacity: 0.4;
        z-index: 999;
        display: none;
      }
      .animation_move1 {
        z-index: 10;
        animation: move1 0.4s;
      }
      .animation_move2 {
        z-index: 10;
        animation: move2 0.4s;
      }
      .animation_move3 {
        z-index: 10;
        animation: move3 0.4s;
      }
      .shu {
        top: 421px;
        left: 237px;
      }
      .shu + i {
        top: 358px;
        left: 302px;
      }
      .niu {
        top: 397px;
        left: 140px;
      }
      .niu + i {
        top: 332px;
        left: -25px;
        background: url("../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .hu {
        top: 328px;
        left: 76px;
      }
      .hu + i {
        top: 262px;
        left: -90px;
        background: url("../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .tu {
        top: 236px;
        left: 51px;
      }
      .tu + i {
        top: 172px;
        left: -115px;
        background: url("../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .long {
        top: 145px;
        left: 76px;
      }
      .long + i {
        top: 81px;
        left: -90px;
        background: url("../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .she {
        top: 77px;
        left: 140px;
      }
      .she + i {
        top: 12px;
        left: -25px;
        background: url("../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .ma {
        top: 51px;
        left: 237px;
      }
      .ma + i {
        top: -14px;
        left: 302px;
      }
      .yang {
        top: 77px;
        left: 332px;
      }
      .yang + i {
        top: 12px;
        left: 394px;
      }
      .hou {
        top: 145px;
        left: 398px;
      }
      .hou + i {
        top: 81px;
        left: 463px;
      }
      .ji {
        top: 236px;
        left: 422px;
      }
      .ji + i {
        top: 172px;
        left: 487px;
      }
      .gou {
        top: 328px;
        left: 398px;
      }
      .gou + i {
        top: 262px;
        left: 463px;
      }
      .zhu {
        top: 397px;
        left: 332px;
      }
      .zhu + i {
        top: 332px;
        left: 394px;
      }
    }
    .mima_box {
      span {
        top: 236px;
        position: absolute;
        background: url("../../assets/img/password/mima_fill.png") center
          no-repeat;
        background-size: 100%;
        img {
          width: 74px;
          height: 74px;
          border-radius: 37px;
        }
      }
      .shake {
        animation: shake 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      .hidden {
        animation: zoomOut 0.5s;
      }
      .bogin_bg_0 {
        width: 74px;
        height: 74px;
        left: 146px;
      }
      .bogin_bg_1 {
        width: 74px;
        height: 74px;
        left: 235px;
      }
      .bogin_bg_2 {
        width: 74px;
        height: 74px;
        left: 324px;
      }
    }
    .tishi {
      position: absolute;
      top: 165px;
      left: 229px;
      font-size: 21px;
      color: #00547E;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      letter-spacing: 0;
      line-height: 42px;
    }
    .clearpassword {
      position: absolute;
      color: #00547E;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      top: 354px;
      left: 252px;
      font-size: 21px;
    }
    .sx_img {
      position: absolute;
      width: 72px;
      height: 72px;
      box-shadow: 1px 2px #003057;
      border-radius: 37px;
    }
    .img_box:active em {
      display: block;
    }
  }
.tipbtn{
  position: relative;
  margin-top: 110px;
  margin-left: 47px;
  .tip{
    width: 260px;
    height: 96px;
    color: #ffffff;
    line-height: 85px;
    font-weight: 500;
    font-family: PingFangSC, PingFangSC-Medium;;
    font-size: 24px;
    background:url(../../assets/img/password/tipbg.png) no-repeat;
    background-size: cover;
  }
  .haili{
    position: absolute;
    width: 152px;
    height: 144px;
    right: -55px;
    top: 84px;
    background:url(../../assets/img/password/haili.png) no-repeat;
    background-size: cover;
  }
  .login_btn {
    margin-top: 185px;
    width: 255px;
    height: 73px;
    font-size: 31px;
    line-height: 73px;
    text-align: center;
    color: #0089ce;
    background: #fff;
    opacity: .4;
    border-radius: 5px;
    transition-duration: 0.5s;
    margin-left: 18px;
    border-radius: 66px;
    cursor: default;
  }
  .login_btn_cur {
    color: #007a9c;
    cursor: pointer;
    background: #ffffff;
    opacity: 1;
  }
  .login_btn_cur:hover {
    background: #cce7f5;
    color: #0077B5;
  }
}
}
</style>


// WEBPACK FOOTER //
// src/components/basic/pwd.vue